<template>
  <!-- 封装的el-select-v2通用组件，适配大数据量虚拟滚动 -->
  <el-select-v2
    v-model="selectValue"
    :placeholder="placeholder"
    :disabled="disabled"
    :options="options"
    :props="{ label: 'company_all', value: 'company_all' }"
    filterable
    @change="handleChange"
  />
</template>

<script setup name="SelectSaleChannel">
import { ref, watch, defineProps, defineEmits } from 'vue'
import { getSaleChannelList } from '@/apis/channel'

// 定义组件Props，遵循Vue3规范，适配el-select-v2特性
const props = defineProps({
  // v-model绑定值，支持字符串/数字/布尔值，多选时为数组
  modelValue: {
    type: [String, Number, Boolean, Array],
    default: ''
  },
  // 输入框占位符
  placeholder: {
    type: String,
    default: '请选择'
  },
  // 是否禁用组件
  disabled: {
    type: Boolean,
    default: false
  }
})

// 定义组件事件，支持v-model更新和change事件透传
const emit = defineEmits(['update:modelValue', 'change', 'select-item'])

// 内部绑定值，作为v-model双向绑定的中间层，解耦父子组件数据
const selectValue = ref(props.modelValue)

const options = ref([])
const getOptions = async () => {
  const { code, data, msg } = await getSaleChannelList()
  if (code != 200) return proxy.$message({ type: 'error', message: msg })

  options.value = data
}
getOptions()

// 监听外部modelValue变化，同步到内部（父组件修改值时，子组件实时更新）
watch(
  () => props.modelValue,
  (newVal) => {
    selectValue.value = newVal
  },
  { immediate: true, deep: true } // 立即执行+深度监听，适配多选数组场景
)

// 监听内部值变化，触发v-model更新（子组件选择值时，同步到父组件）
watch(
  selectValue,
  (newVal) => {
    emit('update:modelValue', newVal)
  },
  { deep: true } // 深度监听，支持多选数组值变化
)

// 下拉值改变事件，透传外部，便于业务逻辑处理
const handleChange = (val) => {
  emit('change', val)
  // 找到选中项的完整数据
  const item = options.value.find(opt => opt.company_all === val)
  if (item) {
    emit('select-item', item)
  }
}
</script>

<style scoped>
/* 自定义基础样式，可根据业务覆盖 */
.common-select-v2 {
  width: 100%; /* 默认宽度100%，外部可通过style/class覆盖 */
  --el-select-v2-option-height: 36px; /* 自定义下拉选项行高，可选 */
}
</style>